var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row justify-content-center" }, [
        _c("div", { staticClass: "col-auto py-5" }, [
          _c("a", { attrs: { href: "/", title: "Control Panel" } }, [
            _c("img", {
              staticClass: "logo",
              attrs: { alt: "control panel", src: _vm.whitelabel.LOGO }
            })
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container position-relative" }, [
      _c("div", { staticClass: "row justify-content-center" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-md-12 col-lg-9 col-xl-7" },
          [_vm._t("default")],
          2
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }